import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CustomImage, Text, useText } from '@src/components';
import { footerLink, personalDataProtectionLaw } from '@src/utils/keys';
import logoEdenred from '@src/assets/images/login/logo-edenred.svg';
import logoEdenredSmall from '@src/assets/images/login/logo-edenred-small.png';
import loginLeftImg2x from '@src/assets/images/login/loginLeftImg@2x.png';
import logintablet3x from '@src/assets/images/login/logintablet@3x.png';
import loginmobile2x from '@src/assets/images/login/loginmobile@2x.png';
import ticketCard from '@src/assets/images/login/ticketCardNew.webp';
import ticketrestaurant from '@src/assets/images/login/logo-ticketrestaurant.svg';
import ticketcar from '@src/assets/images/login/logo-ticketcar.svg';
import compliments from '@src/assets/images/login/logo-ticket-compliments.svg';
import iconBack from '@src/assets/icons/icon-left-back.svg';
import iconLanguageTr from '@src/assets/icons/icon-language-tr.svg';
import iconLanguageEn from '@src/assets/icons/icon-language-en.svg';
import { Select } from 'antd';
import { useLang } from '@src/context';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import '@src/styles/login/loginLayout.scss';
import { DeleteAllCache } from '@src/utils/utils';
import { languageOptions } from '@src/assets/language';

const { Option } = Select;

const LoginLayout = ({ children, isBackButton, className }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });
  const ticketOnlineOrderingPlatformLanguage = useText('ticketOnlineOrderingPlatform');

  const history = useHistory();
  const { languageChange, language } = useLang();

  const changeTitle = useCallback((text) => {
    document.title = text;
  }, []);

  useEffect(() => {
    DeleteAllCache();
  }, []);

  useEffect(() => {
    changeTitle(ticketOnlineOrderingPlatformLanguage);
  }, [language, changeTitle, ticketOnlineOrderingPlatformLanguage]);

  const handleChange = useCallback(
    (value) => {
      languageChange(value);
    },
    [languageChange],
  );

  return (
    <div className={`${className || ''} login-main`}>
      <div className="leftSideMain row justify-content-center p-0 m-0">
        {!isDesktop && isBackButton && (
          <div className="routerLeftButtonMain">
            <div className="routerLeftButtonText" onClick={() => history.push('/login')}>
              <CustomImage className="routerLeftButtonImg" src={iconBack} />
              <span className="routerLeftButtonText">
                <Text t="turnBack" />
              </span>
            </div>
          </div>
        )}

        <div className="row leftSideMainChild ">
          <h3 className="edenredSlogan">
            <Text t={'inCorporatePaymentSolutions'} />
            <br />
            <span>
              <Text t={'turkeyAndWorld'} />
            </span>
            <br />
            <span>
              <Text t={'mostPreferredBrand'} />
            </span>
          </h3>
          <CustomImage src={logoEdenred} className="edenredlogo" />
          <CustomImage src={logoEdenredSmall} className="edenredLogoSmall" />
          <CustomImage src={loginLeftImg2x} className="loginLeftPic p-0" />
          <CustomImage src={logintablet3x} className="loginLeftPicTablet p-0" />
          <CustomImage src={loginmobile2x} className="loginLeftPicMobile p-0" />
          <CustomImage src={ticketCard} className="edenredCardPic" />
          <div className="row edenredTickets m-0  justify-content-start">
            <CustomImage src={ticketrestaurant} className="ticketrestaurant" />
            <CustomImage src={ticketcar} className="ticketcar" />
            <CustomImage src={compliments} className="ticketcompliments" />
          </div>
        </div>
      </div>

      <div className="rightSideMain">
        {isDesktop && isBackButton && (
          <div className="routerLeftButtonMain">
            <div className="routerLeftButtonText" onClick={() => history.push('/login')}>
              <CustomImage className="routerLeftButtonImg" src={iconBack} />
              <span className="routerLeftButtonText">
                <Text t="turnBack" />
              </span>
            </div>
          </div>
        )}

        <div className="rightSideMainChild">
          <div className="rightSideLoginForm">{children}</div>
          <div className="login-right-bottom-menu">
            <div>
              <a
                target="blank"
                className="loginRightBottomMenuButtons"
                href={footerLink?.communication}
                style={{ paddingLeft: '0px' }}
              >
                <Text t="communication" />
              </a>
              <a
                target="blank"
                className="loginRightBottomMenuButtons"
                href={footerLink?.protectionOfPersonalData}
              >
                <Text t="protectionPersonalData" />
              </a>
              <a
                target="blank"
                className="loginRightBottomMenuButtons"
                href={footerLink?.cookiePolicy}
              >
                <Text t="cookiePolicy" />
              </a>
              <div
                className="ot-sdk-show-settings loginRightBottomMenuButtons"
                style={{ cursor: 'pointer', display: 'inline-block', paddingLeft: '0px' }}
                onClick={() => {
                  window?.OneTrust?.initializeCookiePolicyHtml();
                }}
              >
                <Text t="cookieSettings" />
              </div>
              <p className="info-text">
                <Text t="communicationPrefInfoText" />{' '}
                <a href={personalDataProtectionLaw} target="_blank" rel="noreferrer">
                  <Text t="communicationPrefInfoText2" /></a>
              </p>
              <h6 className="copyright">
                <Text t="copyright" />
              </h6>
            </div>
            <div>
              <Select
                defaultValue={language}
                className="custom-select-language-input"
                onChange={handleChange}
                bordered={false}
              >
                <Option value={languageOptions?.turkey}>
                  <CustomImage src={iconLanguageTr} />
                </Option>
                <Option value={languageOptions?.english}>
                  <CustomImage src={iconLanguageEn} />
                </Option>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;
